export default class NomineeMasterTable {
    static RELATIONSHIP_OPTIONS = [
        { value: "01", label: "Aunt" },
        { value: "02", label: "Brother In Law" },
        { value: "03", label: "Brother" },
        { value: "04", label: "Daughter" },
        { value: "05", label: "Daughter In Law" },
        { value: "06", label: "Father" },
        { value: "07", label: "Father In Law" },
        { value: "08", label: "Grand Daughter" },
        { value: "09", label: "Grand Father" },
        { value: "10", label: "Grand Mother" },
        { value: "11", label: "Grand Son" },
        { value: "12", label: "Mother In Law" },
        { value: "13", label: "Mother" },
        { value: "14", label: "Nephew" },
        { value: "15", label: "Niece" },
        { value: "16", label: "Sister" },
        { value: "17", label: "Sister In Law" },
        { value: "18", label: "Son" },
        { value: "19", label: "Son In Law" },
        { value: "20", label: "Spouse" },
        { value: "21", label: "Uncle" },
        { value: "22", label: "Others" },
    ]

    static GUARDIAN_RELATIONSHIP_OPTIONS = [
        { value: "06", label: "Father" },
        { value: "13", label: "Mother" },
        { value: "23", label: "Court Appointed Legal Guardian" },
    ]

    static IDENTITY_TYPE = [
        { value: "1", label: "PAN" },
        { value: "2", label: "Adhaar" },
        { value: "3", label: "Driving License" },
        { value: "4", label: "Passport" },
    ]

    static TAX_ID = [
        { code: "A", label: "Passport" },
        { code: "B", label: "Election ID Card" },
        { code: "C", label: "PAN Card" },
        { code: "D", label: "ID Card" },
        { code: "E", label: "Driving License" },
        { code: "G", label: "UIDIA / Aadhar letter" },
        { code: "H", label: "NREGA Job Card" },
        { code: "O", label: "Others" },
        { code: "X", label: "Not categorized" },
        { code: "T", label: "TIN [Tax Payer Identification Number]" },
        { code: "C1", label: "Company Identification Number" },
        { code: "G1", label: "US GIIN" },
        { code: "E1", label: "Global Entity Identification Number" }
    ];

    static TAX_COUNTRY = [
        { code: "AF", label: "Afghanistan" },
        { code: "AX", label: "Åland Islands" },
        { code: "AL", label: "Albania" },
        { code: "DZ", label: "Algeria" },
        { code: "AS", label: "American Samoa" },
        { code: "AD", label: "Andorra" },
        { code: "AO", label: "Angola" },
        { code: "AI", label: "Anguilla" },
        { code: "AQ", label: "Antarctica" },
        { code: "AG", label: "Antigua and Barbuda" },
        { code: "AR", label: "Argentina" },
        { code: "AM", label: "Armenia" },
        { code: "AW", label: "Aruba" },
        { code: "AU", label: "Australia" },
        { code: "AT", label: "Austria" },
        { code: "AZ", label: "Azerbaijan" },
        { code: "BS", label: "Bahamas" },
        { code: "BH", label: "Bahrain" },
        { code: "BD", label: "Bangladesh" },
        { code: "BB", label: "Barbados" },
        { code: "BY", label: "Belarus" },
        { code: "BE", label: "Belgium" },
        { code: "BZ", label: "Belize" },
        { code: "BJ", label: "Benin" },
        { code: "BM", label: "Bermuda" },
        { code: "BT", label: "Bhutan" },
        { code: "BO", label: "Bolivia (Plurinational State of)" },
        { code: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
        { code: "BA", label: "Bosnia and Herzegovina" },
        { code: "BW", label: "Botswana" },
        { code: "BV", label: "Bouvet Island" },
        { code: "BR", label: "Brazil" },
        { code: "IO", label: "British Indian Ocean Territory" },
        { code: "BN", label: "Brunei Darussalam" },
        { code: "BG", label: "Bulgaria" },
        { code: "BF", label: "Burkina Faso" },
        { code: "BI", label: "Burundi" },
        { code: "CV", label: "Cabo Verde" },
        { code: "KH", label: "Cambodia" },
        { code: "CM", label: "Cameroon" },
        { code: "CA", label: "Canada" },
        { code: "KY", label: "Cayman Islands" },
        { code: "CF", label: "Central African Republic" },
        { code: "TD", label: "Chad" },
        { code: "CL", label: "Chile" },
        { code: "CN", label: "China" },
        { code: "CX", label: "Christmas Island" },
        { code: "CC", label: "Cocos (Keeling) Islands" },
        { code: "CO", label: "Colombia" },
        { code: "KM", label: "Comoros" },
        { code: "CG", label: "Congo" },
        { code: "CD", label: "Congo (Democratic Republic of the)" },
        { code: "CK", label: "Cook Islands" },
        { code: "CR", label: "Costa Rica" },
        { code: "CI", label: "Côte d'Ivoire" },
        { code: "HR", label: "Croatia" },
        { code: "CU", label: "Cuba" },
        { code: "CW", label: "Curaçao" },
        { code: "CY", label: "Cyprus" },
        { code: "CZ", label: "Czech Republic" },
        { code: "DK", label: "Denmark" },
        { code: "DJ", label: "Djibouti" },
        { code: "DM", label: "Dominica" },
        { code: "DO", label: "Dominican Republic" },
        { code: "EC", label: "Ecuador" },
        { code: "EG", label: "Egypt" },
        { code: "SV", label: "El Salvador" },
        { code: "GQ", label: "Equatorial Guinea" },
        { code: "ER", label: "Eritrea" },
        { code: "EE", label: "Estonia" },
        { code: "ET", label: "Ethiopia" },
        { code: "FK", label: "Falkland Islands (Malvinas)" },
        { code: "FO", label: "Faroe Islands" },
        { code: "FJ", label: "Fiji" },
        { code: "FI", label: "Finland" },
        { code: "FR", label: "France" },
        { code: "GF", label: "French Guiana" },
        { code: "PF", label: "French Polynesia" },
        { code: "TF", label: "French Southern Territories" },
        { code: "GA", label: "Gabon" },
        { code: "GM", label: "Gambia" },
        { code: "GE", label: "Georgia" },
        { code: "DE", label: "Germany" },
        { code: "GH", label: "Ghana" },
        { code: "GI", label: "Gibraltar" },
        { code: "GR", label: "Greece" },
        { code: "GL", label: "Greenland" },
        { code: "GD", label: "Grenada" },
        { code: "GP", label: "Guadeloupe" },
        { code: "GU", label: "Guam" },
        { code: "GT", label: "Guatemala" },
        { code: "GG", label: "Guernsey" },
        { code: "GN", label: "Guinea" },
        { code: "GW", label: "Guinea-Bissau" },
        { code: "GY", label: "Guyana" },
        { code: "HT", label: "Haiti" },
        { code: "HM", label: "Heard Island and McDonald Islands" },
        { code: "VA", label: "Holy See" },
        { code: "HN", label: "Honduras" },
        { code: "HK", label: "Hong Kong" },
        { code: "HU", label: "Hungary" },
        { code: "IS", label: "Iceland" },
        { code: "IN", label: "India" },
        { code: "ID", label: "Indonesia" },
        { code: "IR", label: "Iran (Islamic Republic of)" },
        { code: "IQ", label: "Iraq" },
        { code: "IE", label: "Ireland" },
        { code: "IM", label: "Isle of Man" },
        { code: "IL", label: "Israel" },
        { code: "IT", label: "Italy" },
        { code: "JM", label: "Jamaica" },
        { code: "JP", label: "Japan" },
        { code: "JE", label: "Jersey" },
        { code: "JO", label: "Jordan" },
        { code: "KZ", label: "Kazakhstan" },
        { code: "KE", label: "Kenya" },
        { code: "KI", label: "Kiribati" },
        { code: "KP", label: "Korea (Democratic People's Republic of)" },
        { code: "KR", label: "Korea (Republic of)" },
        { code: "KW", label: "Kuwait" },
        { code: "KG", label: "Kyrgyzstan" },
        { code: "LA", label: "Lao People's Democratic Republic" },
        { code: "LV", label: "Latvia" },
        { code: "LB", label: "Lebanon" },
        { code: "LS", label: "Lesotho" },
        { code: "LR", label: "Liberia" },
        { code: "LY", label: "Libya" },
        { code: "LI", label: "Liechtenstein" },
        { code: "LT", label: "Lithuania" },
        { code: "LU", label: "Luxembourg" },
        { code: "MO", label: "Macao" },
        { code: "MK", label: "Macedonia (the former Yugoslav Republic of)" },
        { code: "MG", label: "Madagascar" },
        { code: "MW", label: "Malawi" },
        { code: "MY", label: "Malaysia" },
        { code: "MV", label: "Maldives" },
        { code: "ML", label: "Mali" },
        { code: "MT", label: "Malta" },
        { code: "MH", label: "Marshall Islands" },
        { code: "MQ", label: "Martinique" },
        { code: "MR", label: "Mauritania" },
        { code: "MU", label: "Mauritius" },
        { code: "YT", label: "Mayotte" },
        { code: "MX", label: "Mexico" },
        { code: "FM", label: "Micronesia (Federated States of)" },
        { code: "MD", label: "Moldova (Republic of)" },
        { code: "MC", label: "Monaco" },
        { code: "MN", label: "Mongolia" },
        { code: "ME", label: "Montenegro" },
        { code: "MS", label: "Montserrat" },
        { code: "MA", label: "Morocco" },
        { code: "MZ", label: "Mozambique" },
        { code: "MM", label: "Myanmar" },
        { code: "NA", label: "Namibia" },
        { code: "NR", label: "Nauru" },
        { code: "NP", label: "Nepal" },
        { code: "NL", label: "Netherlands" },
        { code: "NC", label: "New Caledonia" },
        { code: "NZ", label: "New Zealand" },
        { code: "NI", label: "Nicaragua" },
        { code: "NE", label: "Niger" },
        { code: "NG", label: "Nigeria" },
        { code: "NU", label: "Niue" },
        { code: "NF", label: "Norfolk Island" },
        { code: "MP", label: "Northern Mariana Islands" },
        { code: "NO", label: "Norway" },
        { code: "OM", label: "Oman" },
        { code: "PK", label: "Pakistan" },
        { code: "PW", label: "Palau" },
        { code: "PS", label: "Palestine, State of" },
        { code: "PA", label: "Panama" },
        { code: "PG", label: "Papua New Guinea" },
        { code: "PY", label: "Paraguay" },
        { code: "PE", label: "Peru" },
        { code: "PH", label: "Philippines" },
        { code: "PN", label: "Pitcairn" },
        { code: "PL", label: "Poland" },
        { code: "PT", label: "Portugal" },
        { code: "PR", label: "Puerto Rico" },
        { code: "QA", label: "Qatar" },
        { code: "RE", label: "Réunion" },
        { code: "RO", label: "Romania" },
        { code: "RU", label: "Russian Federation" },
        { code: "RW", label: "Rwanda" },
        { code: "BL", label: "Saint Barthélemy" },
        { code: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
        { code: "KN", label: "Saint Kitts and Nevis" },
        { code: "LC", label: "Saint Lucia" },
        { code: "MF", label: "Saint Martin (French part)" },
        { code: "PM", label: "Saint Pierre and Miquelon" },
        { code: "VC", label: "Saint Vincent and the Grenadines" },
        { code: "WS", label: "Samoa" },
        { code: "SM", label: "San Marino" },
        { code: "ST", label: "Sao Tome and Principe" },
        { code: "SA", label: "Saudi Arabia" },
        { code: "SN", label: "Senegal" },
        { code: "RS", label: "Serbia" },
        { code: "SC", label: "Seychelles" },
        { code: "SL", label: "Sierra Leone" },
        { code: "SG", label: "Singapore" },
        { code: "SX", label: "Sint Maarten (Dutch part)" },
        { code: "SK", label: "Slovakia" },
        { code: "SI", label: "Slovenia" },
        { code: "SB", label: "Solomon Islands" },
        { code: "SO", label: "Somalia" },
        { code: "ZA", label: "South Africa" },
        { code: "GS", label: "South Georgia and the South Sandwich Islands" },
        { code: "SS", label: "South Sudan" },
        { code: "ES", label: "Spain" },
        { code: "LK", label: "Sri Lanka" },
        { code: "SD", label: "Sudan" },
        { code: "SR", label: "Suriname" },
        { code: "SJ", label: "Svalbard and Jan Mayen" },
        { code: "SZ", label: "Swaziland" },
        { code: "SE", label: "Sweden" },
        { code: "CH", label: "Switzerland" },
        { code: "SY", label: "Syrian Arab Republic" },
        { code: "TW", label: "Taiwan, Province of China" },
        { code: "TJ", label: "Tajikistan" },
        { code: "TZ", label: "Tanzania, United Republic of" },
        { code: "TH", label: "Thailand" },
        { code: "TL", label: "Timor-Leste" },
        { code: "TG", label: "Togo" },
        { code: "TK", label: "Tokelau" },
        { code: "TO", label: "Tonga" },
        { code: "TT", label: "Trinidad and Tobago" },
        { code: "TN", label: "Tunisia" },
        { code: "TR", label: "Turkey" },
        { code: "TM", label: "Turkmenistan" },
        { code: "TC", label: "Turks and Caicos Islands" },
        { code: "TV", label: "Tuvalu" },
        { code: "UG", label: "Uganda" },
        { code: "UA", label: "Ukraine" },
        { code: "AE", label: "United Arab Emirates" },
        { code: "GB", label: "United Kingdom of Great Britain and Northern Ireland" },
        { code: "UM", label: "United States Minor Outlying Islands" },
        { code: "US", label: "United States of America" },
        { code: "UY", label: "Uruguay" },
        { code: "UZ", label: "Uzbekistan" },
        { code: "VU", label: "Vanuatu" },
        { code: "VE", label: "Venezuela (Bolivarian Republic of)" },
        { code: "VN", label: "Viet Nam" },
        { code: "VG", label: "Virgin Islands (British)" },
        { code: "VI", label: "Virgin Islands (U.S.)" },
        { code: "WF", label: "Wallis and Futuna" },
        { code: "EH", label: "Western Sahara" },
        { code: "YE", label: "Yemen" },
        { code: "ZM", label: "Zambia" },
        { code: "ZW", label: "Zimbabwe" },
        { code: "XX", label: "Not Categorized" },
        { code: "ZZ", label: "Others" }
    ];


    static TIN_ALTERNATE_TAX_ID = [
        { code: "J", label: "Student Visa" },
        { code: "K", label: "Diplomat Visa" },
        { code: "N", label: "Global Entity Identification Number" },
        { code: "Q", label: "US GIIN" },
        { code: "F", label: "Dependent Visa" },
        { code: "I", label: "Social Security ID Card" },
        { code: "M", label: "Mariner/Sea farer (Continuous Discharge Certificate)" },
        { code: "S", label: "Sportsperson/Professional (Appropriate Visa)" },
        { code: "T", label: "TIN [Tax Payer Identification Number]" },
        { code: "D", label: "ID Card (Any ID issued by the authorities of the respective Country), pls find revised ID type master)" },
    ]
    static COUNTRIES = [
        { code: "001", label: "Afghanistan" },
        { code: "002", label: "Aland Islands" },
        { code: "003", label: "Albania" },
        { code: "004", label: "Algeria" },
        { code: "005", label: "American Samoa" },
        { code: "006", label: "Andorra" },
        { code: "007", label: "Angola" },
        { code: "008", label: "Anguilla" },
        { code: "009", label: "Antarctica" },
        { code: "010", label: "Antigua And Barbuda" },
        { code: "011", label: "Argentina" },
        { code: "012", label: "Armenia" },
        { code: "013", label: "Aruba" },
        { code: "014", label: "Australia" },
        { code: "015", label: "Austria" },
        { code: "016", label: "Azerbaijan" },
        { code: "017", label: "Bahamas" },
        { code: "018", label: "Bahrain" },
        { code: "019", label: "Bangladesh" },
        { code: "020", label: "Barbados" },
        { code: "021", label: "Belarus" },
        { code: "022", label: "Belgium" },
        { code: "023", label: "Belize" },
        { code: "024", label: "Benin" },
        { code: "025", label: "Bermuda" },
        { code: "026", label: "Bhutan" },
        { code: "027", label: "Bolivia" },
        { code: "028", label: "Bosnia And Herzegovina" },
        { code: "029", label: "Botswana" },
        { code: "030", label: "Bouvet Island" },
        { code: "031", label: "Brazil" },
        { code: "032", label: "British Indian Ocean Territory" },
        { code: "033", label: "Brunei Darussalam" },
        { code: "034", label: "Bulgaria" },
        { code: "035", label: "Burkina Faso" },
        { code: "036", label: "Burundi" },
        { code: "037", label: "Cambodia" },
        { code: "038", label: "Cameroon" },
        { code: "039", label: "Canada" },
        { code: "040", label: "Cape Verde" },
        { code: "041", label: "Cayman Islands" },
        { code: "042", label: "Central African Republic" },
        { code: "043", label: "Chad" },
        { code: "044", label: "Chile" },
        { code: "045", label: "China" },
        { code: "046", label: "Christmas Island" },
        { code: "047", label: "Cocos (Keeling) Islands" },
        { code: "048", label: "Colombia" },
        { code: "049", label: "Comoros" },
        { code: "050", label: "Congo" },
        { code: "051", label: "Congo, The Democratic Republic Of The" },
        { code: "052", label: "Cook Islands" },
        { code: "053", label: "Costa Rica" },
        { code: "054", label: "Cote DIvoire" },
        { code: "055", label: "Croatia" },
        { code: "056", label: "Cuba" },
        { code: "057", label: "Cyprus" },
        { code: "058", label: "Czech Republic" },
        { code: "059", label: "Denmark" },
        { code: "060", label: "Djibouti" },
        { code: "061", label: "Dominica" },
        { code: "062", label: "Dominican Republic" },
        { code: "063", label: "Ecuador" },
        { code: "064", label: "Egypt" },
        { code: "065", label: "El Salvador" },
        { code: "066", label: "Equatorial Guinea" },
        { code: "067", label: "Eritrea" },
        { code: "068", label: "Estonia" },
        { code: "069", label: "Ethiopia" },
        { code: "070", label: "Falkland Islands (Malvinas)" },
        { code: "071", label: "Faroe Islands" },
        { code: "072", label: "Fiji" },
        { code: "073", label: "Finland" },
        { code: "074", label: "France" },
        { code: "075", label: "French Guiana" },
        { code: "076", label: "French Polynesia" },
        { code: "077", label: "French Southern Territories" },
        { code: "078", label: "Gabon" },
        { code: "079", label: "Gambia" },
        { code: "080", label: "Georgia" },
        { code: "081", label: "Germany" },
        { code: "082", label: "Ghana" },
        { code: "083", label: "Gibraltar" },
        { code: "084", label: "Greece" },
        { code: "085", label: "Greenland" },
        { code: "086", label: "Grenada" },
        { code: "087", label: "Guadeloupe" },
        { code: "088", label: "Guam" },
        { code: "089", label: "Guatemala" },
        { code: "090", label: "Guernsey" },
        { code: "091", label: "Guinea" },
        { code: "092", label: "Guinea-Bissau" },
        { code: "093", label: "Guyana" },
        { code: "094", label: "Haiti" },
        { code: "095", label: "Heard Island And Mcdonald Islands" },
        { code: "096", label: "Holy See (Vatican City State)" },
        { code: "097", label: "Honduras" },
        { code: "098", label: "Hong Kong" },
        { code: "099", label: "Hungary" },
        { code: "100", label: "Iceland" },
        { code: "101", label: "India" },
        { code: "102", label: "Indonesia" },
        { code: "103", label: "Iran, Islamic Republic Of" },
        { code: "104", label: "Iraq" },
        { code: "105", label: "Ireland" },
        { code: "106", label: "Isle Of Man" },
        { code: "107", label: "Israel" },
        { code: "108", label: "Italy" },
        { code: "109", label: "Jamaica" },
        { code: "110", label: "Japan" },
        { code: "111", label: "Jersey" },
        { code: "112", label: "Jordan" },
        { code: "113", label: "Kazakhstan" },
        { code: "114", label: "Kenya   " },
        { code: "115", label: "Kiribati" },
        { code: "116", label: "Korea, Democratic Peoples Republic Of" },
        { code: "117", label: "Korea, Republic Of" },
        { code: "118", label: "Kuwait" },
        { code: "119", label: "Kyrgyzstan" },
        { code: "120", label: "Lao Peoples Democratic Republic" },
        { code: "121", label: "Latvia" },
        { code: "122", label: "Lebanon" },
        { code: "123", label: "Lesotho" },
        { code: "124", label: "Liberia" },
        { code: "125", label: "Libyan Arab Jamahiriya" },
        { code: "126", label: "Liechtenstein" },
        { code: "127", label: "Lithuania" },
        { code: "128", label: "Luxembourg" },
        { code: "129", label: "Macao" },
        { code: "130", label: "Macedonia, The Former Yugoslav Republic Of" },
        { code: "131", label: "Madagascar" },
        { code: "132", label: "Malawi" },
        { code: "133", label: "Malaysia" },
        { code: "134", label: "Maldives" },
        { code: "135", label: "Mali" },
        { code: "136", label: "Malta" },
        { code: "137", label: "Marshall Islands" },
        { code: "138", label: "Martinique" },
        { code: "139", label: "Mauritania" },
        { code: "140", label: "Mauritius" },
        { code: "141", label: "Mayotte" },
        { code: "142", label: "Mexico" },
        { code: "143", label: "Micronesia, Federated States Of" },
        { code: "144", label: "Moldova, Republic Of" },
        { code: "145", label: "Monaco" },
        { code: "146", label: "Mongolia" },
        { code: "147", label: "Montserrat" },
        { code: "148", label: "Morocco" },
        { code: "149", label: "Mozambique" },
        { code: "150", label: "Myanmar" },
        { code: "151", label: "Namibia" },
        { code: "152", label: "Nauru   " },
        { code: "153", label: "Nepal" },
        { code: "154", label: "Netherlands" },
        { code: "155", label: "Netherlands Antilles" },
        { code: "156", label: "New Caledonia" },
        { code: "157", label: "New Zealand" },
        { code: "158", label: "Nicaragua" },
        { code: "159", label: "Niger" },
        { code: "160", label: "Nigeria" },
        { code: "161", label: "Niue" },
        { code: "162", label: "Norfolk Island" },
        { code: "163", label: "Northern Mariana Islands" },
        { code: "164", label: "Norway" },
        { code: "165", label: "Oman" },
        { code: "166", label: "Pakistan" },
        { code: "167", label: "Palau" },
        { code: "168", label: "Palestinian Territory, Occupied" },
        { code: "169", label: "Panama" },
        { code: "170", label: "Papua New Guinea" },
        { code: "171", label: "Paraguay" },
        { code: "172", label: "Peru" },
        { code: "173", label: "Philippines" },
        { code: "174", label: "Pitcairn" },
        { code: "175", label: "Poland" },
        { code: "176", label: "Portugal" },
        { code: "177", label: "Puerto Rico" },
        { code: "178", label: "Qatar" },
        { code: "179", label: "Reunion" },
        { code: "180", label: "Romania" },
        { code: "181", label: "Russian Federation" },
        { code: "182", label: "Rwanda" },
        { code: "183", label: "Saint Helena" },
        { code: "184", label: "Saint Kitts And Nevis" },
        { code: "185", label: "Saint Lucia" },
        { code: "186", label: "Saint Pierre And Miquelon" },
        { code: "187", label: "Saint Vincent And The Grenadines" },
        { code: "188", label: "Samoa" },
        { code: "189", label: "San Marino" },
        { code: "190", label: "Sao Tome And Principe" },
        { code: "191", label: "Saudi Arabia   " },
        { code: "192", label: "Senegal" },
        { code: "193", label: "Serbia And Montenegro" },
        { code: "194", label: "Seychelles" },
        { code: "195", label: "Sierra Leone" },
        { code: "196", label: "Singapore" },
        { code: "197", label: "Slovakia" },
        { code: "198", label: "Slovenia" },
        { code: "199", label: "Solomon Islands" },
        { code: "200", label: "Somalia" },
        { code: "201", label: "South Africa" },
        { code: "202", label: "South Georgia And The South Sandwich Islands" },
        { code: "203", label: "Spain" },
        { code: "204", label: "Sri Lanka" },
        { code: "205", label: "Sudan" },
        { code: "206", label: "Suriname" },
        { code: "207", label: "Svalbard And Jan Mayen" },
        { code: "208", label: "Swaziland" },
        { code: "209", label: "Sweden" },
        { code: "210", label: "Switzerland" },
        { code: "211", label: "Syrian Arab Republic" },
        { code: "212", label: "Taiwan, Province Of China" },
        { code: "213", label: "Tajikistan" },
        { code: "214", label: "Tanzania, United Republic Of" },
        { code: "215", label: "Thailand" },
        { code: "216", label: "Timor-Leste" },
        { code: "217", label: "Togo" },
        { code: "218", label: "Tokelau" },
        { code: "219", label: "Tonga" },
        { code: "220", label: "Trinidad And Tobago" },
        { code: "221", label: "Tunisia" },
        { code: "222", label: "Turkey" },
        { code: "223", label: "Turkmenistan" },
        { code: "224", label: "Turks And Caicos Islands" },
        { code: "225", label: "Tuvalu" },
        { code: "226", label: "Uganda" },
        { code: "227", label: "Ukraine" },
        { code: "228", label: "United Arab Emirates" },
        { code: "229", label: "United Kingdom" },
        { code: "230", label: "United States of America" },
        { code: "231", label: "United States Minor Outlying Islands" },
        { code: "232", label: "Uruguay" },
        { code: "233", label: "Uzbekistan" },
        { code: "234", label: "Vanuatu" },
        { code: "235", label: "Venezuela" },
        { code: "236", label: "Viet Nam" },
        { code: "237", label: "Virgin Islands, British" },
        { code: "238", label: "Virgin Islands, U.S." },
        { code: "239", label: "Wallis And Futuna" },
        { code: "240", label: "Western Sahara" },
        { code: "241", label: "Yemen" },
        { code: "242", label: "Zambia" },
        { code: "243", label: "Zimbabwe" }
    ];
}